// extracted by mini-css-extract-plugin
export var glyph = "Icon-module--glyph--56917";
export var icon = "Icon-module--icon--48ffe";
export var inverted = "Icon-module--inverted--722fe";
export var outline = "Icon-module--outline--86c57";